import {
  SiCoursera,
  SiCplusplus,
  SiJava,
  SiJavascript,
  SiPython,
  SiRust,
  SiMongodb,
  SiMysql,
  SiReact,
  SiPytorch,
  SiVuedotjs,
  SiNodedotjs,
  SiAngular,
  SiTensorflow,
  SiDjango,
  SiFlask,
  SiRedis,
  SiTypescript,
} from 'react-icons/si';
import { FcElectronics } from 'react-icons/fc';
import { GiSatelliteCommunication } from 'react-icons/gi';
import { MdQuiz } from 'react-icons/md';
export const quizzes = [
  {
    label: 'C',
    key: 'c',
    isBeta: false,
    icon: SiCoursera,
  },
  {
    label: 'C++',
    key: 'cpp',
    isBeta: false,
    icon: SiCplusplus,
  },
  {
    label: 'Java',
    key: 'java',
    isBeta: false,
    icon: SiJava,
  },
  {
    label: 'Javascript',
    key: 'js',
    isBeta: false,
    icon: SiJavascript,
  },
  {
    label: 'Typescript',
    key: 'typescript',
    isBeta: true,
    icon: SiTypescript,
  },
  {
    label: 'Python',
    key: 'python',
    isBeta: false,
    icon: SiPython,
  },
  {
    label: 'Rust',
    key: 'rust',
    isBeta: false,
    icon: SiRust,
  },
  {
    label: 'React.js',
    key: 'react',
    isBeta: true,
    icon: SiReact,
  },
  {
    label: 'Vue',
    key: 'vue',
    isBeta: true,
    icon: SiVuedotjs,
  },
  {
    label: 'Angular',
    key: 'angular',
    isBeta: true,
    icon: SiAngular,
  },
  {
    label: 'Node JS',
    key: 'node',
    isBeta: true,
    icon: SiNodedotjs,
  },
  {
    label: 'Django',
    key: 'django',
    isBeta: true,
    icon: SiDjango,
  },
  {
    label: 'Flask',
    key: 'flask',
    isBeta: true,
    icon: SiFlask,
  },
  {
    label: 'My Sql',
    key: 'mysql',
    isBeta: false,
    icon: SiMysql,
  },
  {
    label: 'Mongo DB',
    key: 'mongodb',
    isBeta: false,
    icon: SiMongodb,
  },
  {
    label: 'Redis',
    key: 'redis',
    isBeta: true,
    icon: SiRedis,
  },
  {
    label: 'Pytorch',
    key: 'pytorch',
    isBeta: true,
    icon: SiPytorch,
  },
  {
    label: 'Tensorflow',
    key: 'tensorflow',
    isBeta: true,
    icon: SiTensorflow,
  },
  {
    label: 'Analog Communication',
    key: 'analog',
    isBeta: false,
    icon: GiSatelliteCommunication,
  },
  {
    label: 'Digital Electronics',
    key: 'digital',
    isBeta: false,
    icon: FcElectronics,
  },
  {
    label: 'E&I',
    key: 'E&I',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Automobile Engineering',
    key: 'automobile',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Food Technology',
    key: 'foodtech',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Chemical Engineering',
    key: 'chemical',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Civil Engineering',
    key: 'civil',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Electrical',
    key: 'eee',
    isBeta: false,
    icon: MdQuiz,
  },
  {
    label: 'Mechanical Engineering',
    key: 'mechanical',
    isBeta: false,
    icon: MdQuiz,
  },
];
